import { Button, Divider, Rate, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useRatingFilter } from "../filters/useRatingFilter";

const FilterRating = ({ talentFilter, talentFilterTags, onAddFilter }) => {
  const {
    rating,
    isUnrated,
    isDisabled,
    setMin,
    setMax,
    setIsUnrated,
    buildRatingFilter,
  } = useRatingFilter(talentFilter, talentFilterTags);

  const handleAdd = () => {
    const payload = buildRatingFilter();
    if (!payload) return;

    onAddFilter("rating", payload);
  };

  return (
    <div className="px-[12px] py-[12px]">
      <div className="pb-[10px]">Select a range</div>

      <div className="mb-[16px]">
        <div>MIN</div>
        <Rate allowHalf onChange={setMin} value={rating.start_value} />
        <span className="ml-2">Rating: {rating.start_value} out of 5</span>
      </div>

      <div>MAX</div>
      <Rate allowHalf onChange={setMax} value={rating.end_value} />
      <span className="ml-2">Rating: {rating.end_value} out of 5</span>

      <Divider className="!text-xs">AND</Divider>

      <div className="mb-[8px]">INCLUDE UNRATED PROFILES</div>
      <Switch
        checked={isUnrated}
        onChange={setIsUnrated}
        checkedChildren="Included"
        unCheckedChildren="Not included"
      />

      <div className="text-right">
        <Button
          disabled={isDisabled}
          className="mt-[10px]"
          onClick={handleAdd}
          icon={<PlusOutlined />}
        >
          Add Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterRating;
